import * as React from 'react';
const SvgSearch = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M8.017 12.68q-1.948 0-3.314-1.367T3.337 8t1.366-3.314Q6.069 3.321 8.016 3.32q1.948 0 3.313 1.366T12.695 8a4.6 4.6 0 0 1-.268 1.563 5 5 0 0 1-.727 1.347l4.587 4.587q.172.172.177.372t-.177.38a.54.54 0 0 1-.387.182.54.54 0 0 1-.387-.181l-4.587-4.566a5 5 0 0 1-1.37.735q-.745.26-1.54.26m-.001-1.084q1.506 0 2.551-1.045T11.612 8t-1.045-2.552Q9.523 4.404 8.016 4.403q-1.506 0-2.551 1.045T4.42 8t1.045 2.55q1.045 1.047 2.551 1.046'
            />
        </g>
    </svg>
);
export default SvgSearch;
